import { paths } from "@utils/navigation";

const { vesselManagement } = paths;

export const steps = (bunkerBargeChecked?: boolean) => [
  {
    label: "vessel-management.vessel-information",
    path: vesselManagement.vesselInformation,
  },
  {
    label: "vessel-management.vessel-particulars",
    path: vesselManagement.vesselType,
  },
  {
    label: "vessel-management.vessel-ownership",
    path: vesselManagement.vesselOwnership,
  },
  {
    label: "vessel-management.vessel-certificates",
    path: vesselManagement.vesselCertificates,
  },
  {
    label: "vessel-management.additional-documents",
    path: vesselManagement.additionalDocuments,
  },
  ...(bunkerBargeChecked
    ? [
        {
          label: "vessel-management.bunker-barge",
          path: vesselManagement.bunkerBarge,
        },
      ]
    : []),
];
